<div [id]="testId" class="custom-tooltip">
    <div class="title" [id]="testId + '-title'">
        {{ params?.colDef?.tooltipComponentParams?.tooltipTitle }}
    </div>
    <div [id]="testId + '-value'">
        {{ params?.value }}
    </div>
</div>
